import { ReactElement } from 'react';
import { useFormikContext, Field, getIn } from 'formik';
import { FormType } from '@constants';
import { LimitedTextArea, FileUploadGroup, TileRadio } from '@components';
import { tile } from '@interfaces/interfaces';
import { iExtensionFormValues } from '@services/ExtensionService';

function ExtensionStep7(): ReactElement {
  const { values }: { values: iExtensionFormValues } = useFormikContext();
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );
  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];
  return (
    <>
      <div className="vfH2">Your financial details</div>
      <p className="subHeadingH3">To help us assess your application, you'll need to provide us with information about your income, expenses and assets.</p>
      <Field name="ExceptionalCircumstances" component={TileRadio} tileData={TILE_DATA} title="Do you have any exceptional financial circumstances you would like to let us know about?" isMandatory orientationRow />
      {getIn(values, 'ExceptionalCircumstances') === 'true' && (
        <>
          <Field component={LimitedTextArea} name="DetailsForCircumstances" value={values.DetailsForCircumstances} limit={340} title="Provide details for any circumstances you would like to be considered for in this application." isMandatory />
          <p className="vfH3">You may also provide any supporting documents (optional)</p>
          <p>Attach any supporting documents (maximum of 5 files - each file should be less than 4MB)</p>
          <FileUploadGroup
            uploadAReport="OtherSupportingDocNameField"
            uploadFieldArrayName="OtherSupportingAttachments"
            whoPrepared="OtherSupportingFilesProvider"
            briefDescription="OtherSupportingFilesDescription"
            fileSizeErrorField="OtherReportNameFieldErrorHandle"
            fileUploadFailErrorField="OtherReportNameFileUploadErrorHandle"
            UploadFileSectionError="OtherUploadFileSectionError"
            fileSizelimit="4"
            totalFileLimit={5}
            hasPrepared={false}
            hasDescribe={false}
            formType={FormType.EXTENSION} />
        </>
      )}
      <br />
    </>
  );
}

export default ExtensionStep7;
